import React from "react";
import "./nodata.scss";
import Logo from "../assets/img/fav.png";
const Errors = () => {
  return (
    <div className="InSidepageSection">
      <div className="wrapper">
        <div className="InsideFlex">
          <div>
            <img src={Logo} alt="Company Logo" />
            <h1>Server did not respond</h1>
            <p>Contact to Administrator</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Errors;
